import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik & Yup
import { Field, useFormikContext } from "formik";
import * as Yup from "yup";

// Country & State components
import Tooltip from "@mui/material/Tooltip";
import { Country, State } from "country-state-city";

// React-Select component and styling
import VerifiedIcon from "@mui/icons-material/Verified";
import Select from "react-select";
// or CheckCircleIcon, DoneIcon, etc.

// @mui material components
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { toast, ToastContainer } from "react-toastify";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

import BasicLayout from "layouts/authentication/components/BasicLayoutForForm";

// Utils component
import { useField } from "formik";
import TextError from "utils/TextError";
import "../../utils/input.css";
import FormFileUpload from "./utils/FormFileUpload";
import FormSelect from "./utils/FormSelect";
import FormTextField from "./utils/FormTextField";
import MultiStepForm, { FormStep } from "./utils/MultiStepForm";

// Router components
import { useNavigate } from "react-router-dom";

// Store
import {
  createVendorDetails,
  getDataByGstNumber,
  getLastFilledDataByVendorId,
  getVendorByVendorId,
  rejectedVendorDetails,
} from "../../store";

// Cookies
import Cookies from "universal-cookie";

import { InputAdornment } from "@mui/material";
import Config from "../../config/validationSchema";
const cookies = new Cookies();

const submitModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const StandardVendorForm = ({
  createVendorDetails,
  rejectedVendorDetails,
  getRejectedVendorDetails,
  rejectedVendorReducer,
  vendorIdReducer,
  gstReducer,
  getDataByGstNumber,
  getLastFilledDataByVendorId,
  getLastFilledDataByVendorIdReducer,
}) => {
  let vendorIdForLastFilled = cookies.get("vendor-email");

  let vendorUserId = cookies.get("vendorId-for-last-filled");

  let isFilledData = cookies.get("isFilledData");

  console.log("isFilledData", isFilledData);

  let alreadyExists = cookies.get("alreadyExists");

  useEffect(() => {
    getLastFilledDataByVendorId(vendorIdForLastFilled);
  }, [vendorIdForLastFilled]);

  const [shouldAutoFillPinCode, setShouldAutoFillPinCode] = useState(false);

  const PincodeAutoFill = ({
    gstReducer,
    shouldAutoFillPinCode,
    setShouldAutoFillPinCode,
  }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();

    useEffect(() => {
      if (!shouldAutoFillPinCode) return;

      const pinCode = gstReducer?.gstData?.data?.addr?.pncd || "";
      const gstNo = gstReducer?.gstData?.data?.gstin || null;

      if (gstNo && pinCode) {
        setFieldValue("pinCode", pinCode);
        setFieldTouched("pinCode", true, false);
      } else {
        // Clear if no data
        setFieldValue("pinCode", "");
        setFieldTouched("pinCode", false, false);
      }

      // Reset the flag after autofill so it runs only once per verification
      setShouldAutoFillPinCode(false);
    }, [
      shouldAutoFillPinCode,
      gstReducer,
      setFieldValue,
      setFieldTouched,
      setShouldAutoFillPinCode,
    ]);

    return null;
  };

  // const StreetAutoFill = ({ gstReducer }) => {
  //   const { setFieldValue, values } = useFormikContext();

  //   useEffect(() => {
  //     const addrData = gstReducer?.gstData?.data?.adr;

  //     // ✅ Autofill only if API has address AND user hasn't typed anything
  //     if (addrData && !values.street) {
  //       setFieldValue("street", addrData);
  //     }
  //     // ⚠️ Notice: we do NOT depend on values.street here
  //     // otherwise it would keep resetting when user clears
  //   }, [gstReducer, setFieldValue]);

  //   return null;
  // };

  const [shouldAutoFillStreet, setShouldAutoFillStreet] = useState(false);

  const StreetAutoFill = ({
    gstReducer,
    shouldAutoFillStreet,
    setShouldAutoFillStreet,
  }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();

    useEffect(() => {
      if (!shouldAutoFillStreet) return;

      const addrData = gstReducer?.gstData?.data?.adr || "";
      const gstNo = gstReducer?.gstData?.data?.gstin || null;

      if (gstNo && addrData) {
        setFieldValue("street", addrData);
        setFieldTouched("street", true, false);
      } else {
        // Clear if no data
        setFieldValue("street", "");
        setFieldTouched("street", false, false);
      }

      // Reset flag so autofill only runs once per verification
      setShouldAutoFillStreet(false);
    }, [
      shouldAutoFillStreet,
      gstReducer,
      setFieldValue,
      setFieldTouched,
      setShouldAutoFillStreet,
    ]);

    return null;
  };

  const SupplierNameAutoFill = ({
    gstReducer,
    shouldAutoFillSupplierName,
    setShouldAutoFillSupplierName,
  }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
      if (!shouldAutoFillSupplierName) return;

      const supplierNameFromGST = gstReducer?.gstData?.data?.lgnm || "";
      const gstNo = gstReducer?.gstData?.data?.gstin || null;

      if (gstNo && supplierNameFromGST) {
        setFieldValue("supplierName", supplierNameFromGST);
      }

      // Reset flag so we don’t autofill again unintentionally
      setShouldAutoFillSupplierName(false);
    }, [
      shouldAutoFillSupplierName,
      gstReducer,
      setFieldValue,
      setShouldAutoFillSupplierName,
    ]);

    return null;
  };
  const [shouldAutoFillState, setShouldAutoFillState] = useState(false);

  const StateNameAutoFill = ({
    gstReducer,
    shouldAutoFillState,
    setShouldAutoFillState,
  }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();

    useEffect(() => {
      if (!shouldAutoFillState) return;

      const stateName = gstReducer?.gstData?.data?.addr?.stcd || "";
      const gstNo = gstReducer?.gstData?.data?.gstin || null;

      if (gstNo && stateName) {
        setFieldValue("state", stateName);
        setFieldTouched("state", true, false);
      }

      // Reset flag so it only autofills once per verification
      setShouldAutoFillState(false);
    }, [
      shouldAutoFillState,
      gstReducer,
      setFieldValue,
      setFieldTouched,
      setShouldAutoFillState,
    ]);

    return null;
  };

  const navigate = useNavigate();

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      return (event.returnValue = "");
    };
    window.addEventListener("beforeunload", handleBeforeUnload, {
      capture: true,
    });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  let token = cookies.get("vendor-portal-jwtToken");
  let email = cookies.get("vendor-email");

  const EmailAutoFill = () => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
      const email = cookies.get("vendor-email");
      if (email) {
        setFieldValue("email", email);
      }
    }, [setFieldValue]);

    return null;
  };

  const [loading, setLoading] = useState(true);

  const [rejectedVendorData, setRejectedVendorData] = useState({});

  const [showCopyLastFilledModal, setShowCopyLastFilledModal] = useState(
    alreadyExists == 0 ? false : true,
  );

  const [vendorId, setVendorId] = useState("");
  console.log(vendorIdReducer);
  useEffect(() => {
    setVendorId(vendorIdReducer.vendorId);
  }, [vendorIdReducer]);

  useEffect(() => {
    getRejectedVendorDetails(vendorId);
  }, [vendorId]);

  useEffect(() => {
    if (rejectedVendorData.email) {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }, [rejectedVendorData]);

  const [countriesOptions, setCountriesOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [currenciesOptions, setCurrenciesOptions] = useState([]);

  const lineOfBusinessOptions = [
    { label: "Direct Material", value: "Direct Material" },
    { label: "Indirect Material", value: "Indirect Material" },
    { label: "Others", value: "Others" },
  ];

  const industrialTypeOptions = [
    { label: "Dealer", value: "Dealer" },
    { label: "Manufacturer", value: "Manufacturer" },
    { label: "Service", value: "Service" },
    { label: "Sub-Contractor", value: "Sub-Contractor" },
    { label: "Trader", value: "Trader" },
    { label: "Others", value: "Others" },
  ];

  const accountTypeOptions = [
    { label: "Current Account", value: "Current Account" },
    { label: "Savings Account", value: "Savings Account" },
  ];

  const sezOptions = [
    { label: "SEZ", value: "SEZ" },
    { label: "Non-SEZ", value: "Non-SEZ" },
  ];

  const rcmOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const categoryOfSupplyOptions = [
    { label: "Material", value: "Material" },
    { label: "Services", value: "Services" },
    { label: "Man Power", value: "Man Power" },
    { label: "Others", value: "Others" },
  ];

  useEffect(() => {
    let countries = Country.getAllCountries();

    let tempCountries = [];
    let currencySet = new Set(); // To track unique currencies
    let tempCurrencies = [];

    countries.forEach((country) => {
      let countryObj = {
        label: country.name,
        value: country.name,
        isoCode: country.isoCode,
        phoneCode: country.phonecode,
      };
      tempCountries.push(countryObj);

      // Only add currency if it's not already seen and not null/empty
      if (country.currency && !currencySet.has(country.currency)) {
        currencySet.add(country.currency);
        tempCurrencies.push({
          label: country.currency,
          value: country.currency,
        });
      }
    });

    setCountriesOptions(tempCountries);
    setCurrenciesOptions(tempCurrencies);
  }, []);

  useEffect(() => {
    setRejectedVendorData(rejectedVendorReducer.getVendor);
    cookies.set(
      "previous-vendorUserId",
      rejectedVendorReducer?.getVendor?.vendorId,
      { path: "/" },
    );
  }, [rejectedVendorReducer]);

  // useEffect(() => {

  // }, [getLastFilledDataByVendorIdReducer]);
  console.log(getLastFilledDataByVendorIdReducer);
  useEffect(() => {
    if (countriesOptions.length > 0) {
      const indiaOption = countriesOptions.find(
        (country) => country.isoCode === "IN",
      );
      if (indiaOption) {
        setCountrySelected(indiaOption);
        setCountryCodeSelected(indiaOption.phoneCode);
      }
    }
  }, [countriesOptions]);

  const [currencySelected, setCurrencySelected] = useState({});

  useEffect(() => {
    if (currenciesOptions.length > 0) {
      const inrOption = currenciesOptions.find(
        (currency) => currency.value === "INR",
      );
      if (inrOption) {
        setCurrencySelected(inrOption);
      }
    }
  }, [currenciesOptions]);

  const [countrySelected, setCountrySelected] = useState({});
  const [countryCodeSelected, setCountryCodeSelected] = useState("");
  const [touched, setTouched] = useState(false);

  const [state, setState] = useState({});

  const stateChangeHandler = (values) => {
    setState(values);
  };

  useEffect(() => {
    let states = State.getStatesOfCountry(countrySelected?.isoCode);

    let arr = [];
    states.map((state) => {
      let stateObj = {
        label: state.name,
        value: state.name,
      };
      arr.push(stateObj);
    });
    setStateOptions(arr);
  }, [countrySelected]);

  useEffect(() => {
    if (rejectedVendorData.email) {
      setCountryCodeSelected(rejectedVendorData.contactDetails?.countryCode);
      setCountrySelected({
        label: rejectedVendorData.address?.country,
        value: rejectedVendorData.address?.country,
      });
    }
  }, [rejectedVendorData]);

  const initialValues = {
    // step 1 initial values
    lineOfBusiness: rejectedVendorData.lineOfBusiness
      ? rejectedVendorData.lineOfBusiness
      : "",
    currency: rejectedVendorData.currency
      ? rejectedVendorData.currency
      : currencySelected?.value,
    supplierName: rejectedVendorData.supplierName
      ? rejectedVendorData.supplierName
      : "",

    gstNo: rejectedVendorData.gstNo ? rejectedVendorData.gstNo : "",
    buildingNoName:
      rejectedVendorData.address?.buildingNoName &&
      rejectedVendorData.address?.buildingNoName !== undefined
        ? rejectedVendorData.address?.buildingNoName
        : "",
    floor:
      rejectedVendorData.address?.floor &&
      rejectedVendorData.address?.floor !== undefined
        ? rejectedVendorData.address?.floor
        : "",
    street: rejectedVendorData.address?.street
      ? rejectedVendorData.address?.street
      : "",
    country: rejectedVendorData.address?.country
      ? rejectedVendorData.address?.country
      : "",
    state: rejectedVendorData.address?.state
      ? rejectedVendorData.address?.state
      : "",
    city: rejectedVendorData.address?.city
      ? rejectedVendorData.address?.city
      : "",
    pinCode: rejectedVendorData.address?.pinCode
      ? rejectedVendorData.address?.pinCode
      : "",
    contactPerson: rejectedVendorData.contactPerson
      ? rejectedVendorData.contactPerson
      : "",
    countryCode: rejectedVendorData.contactDetails?.countryCode
      ? rejectedVendorData.contactDetails?.countryCode
      : "",
    contactNo: rejectedVendorData.contactDetails?.contactNo
      ? rejectedVendorData.contactDetails?.contactNo
      : "",
    industrialType: rejectedVendorData.industrialType
      ? rejectedVendorData.industrialType
      : [],
    email: rejectedVendorData.email ? rejectedVendorData.email : "",

    // step 2 initial values
    pan: rejectedVendorData.pan ? rejectedVendorData.pan : "",

    sezNonsez: rejectedVendorData.sezNonsez ? rejectedVendorData.sezNonsez : "",
    rcmApplicable: rejectedVendorData.rcmApplicable
      ? rejectedVendorData.rcmApplicable
      : "",
    lutNo: rejectedVendorData.lutNo ? rejectedVendorData.lutNo : "",
    lutDate: rejectedVendorData.lutDate ? rejectedVendorData.lutDate : "",
    paymentTerms: rejectedVendorData.paymentTerms
      ? rejectedVendorData.paymentTerms
      : "",
    cinNumber: rejectedVendorData.cinNumber ? rejectedVendorData.cinNumber : "",
    msmedAct: rejectedVendorData.msmedAct ? rejectedVendorData.msmedAct : "",
    tdsLowerDeduction: rejectedVendorData.tdsLowerDeduction
      ? rejectedVendorData.tdsLowerDeduction
      : "",
    categoryOfSupply: rejectedVendorData.categoryOfSupply
      ? rejectedVendorData.categoryOfSupply
      : [],
    pfAccountNumber: rejectedVendorData.pfAccountNumber
      ? rejectedVendorData.pfAccountNumber
      : "",
    esiAccountNumber: rejectedVendorData.esiAccountNumber
      ? rejectedVendorData.esiAccountNumber
      : "",
    // step 3 initial values
    beneficiaryBank: rejectedVendorData.bankDetails?.beneficiaryBank
      ? rejectedVendorData.bankDetails?.beneficiaryBank
      : "",
    bankAddress: rejectedVendorData.bankDetails?.bankAddress
      ? rejectedVendorData.bankDetails?.bankAddress
      : "",
    accountNumber: rejectedVendorData.bankDetails?.accountNumber
      ? rejectedVendorData.bankDetails?.accountNumber
      : "",
    accountType: rejectedVendorData.bankDetails?.accountType
      ? rejectedVendorData.bankDetails?.accountType
      : "",
    accountName: rejectedVendorData.bankDetails?.accountName
      ? rejectedVendorData.bankDetails?.accountName
      : "",
    ifscCode: rejectedVendorData.bankDetails?.ifscCode
      ? rejectedVendorData.bankDetails?.ifscCode
      : "",
    swiftCodeIban: rejectedVendorData.bankDetails?.swiftCodeIban
      ? rejectedVendorData.bankDetails?.swiftCodeIban
      : "",
    intermediaryRoutingBank: rejectedVendorData.bankDetails
      ?.intermediaryRoutingBank
      ? rejectedVendorData.bankDetails?.intermediaryRoutingBank
      : "",
    swiftCodeOfIntermediaryRoutingBank: rejectedVendorData.bankDetails
      ?.swiftCodeOfIntermediaryRoutingBank
      ? rejectedVendorData.bankDetails?.swiftCodeOfIntermediaryRoutingBank
      : "",

    // step 4 inital values
    incorporationCertificate: rejectedVendorData.attachments
      ?.incorporationCertificate
      ? rejectedVendorData.attachments?.incorporationCertificate
      : "",
    cancelledCheque: rejectedVendorData.attachments?.cancelledCheque
      ? rejectedVendorData.attachments?.cancelledCheque
      : "",
    panCard: rejectedVendorData.attachments?.panCard
      ? rejectedVendorData.attachments?.panCard
      : "",
    gstRegistrationCertificate: rejectedVendorData.attachments
      ?.gstRegistrationCertificate
      ? rejectedVendorData.attachments?.gstRegistrationCertificate
      : "",
    validLut: rejectedVendorData.attachments?.validLut
      ? rejectedVendorData.attachments?.validLut
      : "",
    sezApproval: rejectedVendorData.attachments?.sezApproval
      ? rejectedVendorData.attachments?.sezApproval
      : "",
    pfCertificate: rejectedVendorData.attachments?.pfCertificate
      ? rejectedVendorData.attachments?.pfCertificate
      : "",
    esiCertificate: rejectedVendorData.attachments?.esiCertificate
      ? rejectedVendorData.attachments?.esiCertificate
      : "",
    tdsLowerDeductionCertificate: rejectedVendorData.attachments
      ?.tdsLowerDeductionCertificate
      ? rejectedVendorData.attachments?.tdsLowerDeductionCertificate
      : "",
    msmeCertificate: rejectedVendorData.attachments?.msmeCertificate
      ? rejectedVendorData.attachments?.msmeCertificate
      : "",
  };

  const validationSchemaForStepOne = Yup.object(
    Config.validationSchemaForStepOne,
  );

  const validationSchemaForStepTwo = Yup.object(
    Config.validationSchemaForStepTwo,
  );

  const validationSchemaForStepThree = Yup.object(
    Config.validationSchemaForStepThree,
  );

  const validationSchemaForStepFour = Yup.object(
    Config.validationSchemaForStepFour,
  );

  const [errorMsgFormSubmit, setErrorMsgFormSubmit] = useState("");
  const [dataForSubmit, setDataForSubmit] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  const submitFormHandler = async () => {
    dataForSubmit.country = countrySelected.value;
    dataForSubmit.countryCode = countryCodeSelected;

    // ✅ Get supplier name and pincode directly from GST API response
    const gstSupplierName = gstReducer?.gstData?.data?.lgnm || "";
    const gstPinCode = gstReducer?.gstData?.data?.addr?.pncd || "";
    const gstAddress = gstReducer?.gstData?.data?.addr || "";
    const gstSts = gstReducer?.gstData?.data?.sts || "";
    const gstEinvoice = gstReducer?.gstData?.data?.einvoiceStatus || "";
    const gstAdr = gstReducer?.gstData?.data?.adr || "";
    console.log(gstAddress);
    dataForSubmit.gstSupplierName = gstSupplierName;
    dataForSubmit.gstPinCode = gstPinCode;

    dataForSubmit.addr = JSON.stringify(cookies.get("gstVerifiedDataAddr"));
    dataForSubmit.einvoiceStatus = gstEinvoice;
    dataForSubmit.sts = gstSts;
    dataForSubmit.adr = gstAdr;

    dataForSubmit.vendorUserId = vendorUserId;

    dataForSubmit.alreadyExists = cookies.get("alreadyExists");

    if (alreadyExists && alreadyExists == 1) {
      dataForSubmit.previousVendorName = rejectedVendorData.vendorName;
      dataForSubmit.previousVendorUserId = rejectedVendorData.vendorId;
      dataForSubmit.previousAttachments = JSON.stringify(
        rejectedVendorData.attachments,
      );
    }
    console.log("dataForSubmit", rejectedVendorData);
    let payload = new FormData();
    for (let value in dataForSubmit) {
      payload.append(value, dataForSubmit[value]);
    }

    let res;

    if (isFilledData && isFilledData == 1) {
      res = await rejectedVendorDetails(payload, token);
    } else {
      res = await createVendorDetails(payload, token);
    }

    if (res.status) {
      setIsSuccessFormSubmit(true);
      setTimeout(() => {
        handleCloseSubmitModal();
        setFormSubmitted(true);
      }, 3000);

      cookies.remove("vendor-portal-jwtToken");
    }
    if (!res.status) {
      setErrorMsgFormSubmit(res?.data?.data?.msg);
      setIsErrorFormSubmit(true);
    }
  };

  const [openSubmitModal, setOpenSubmitModal] = useState(false);

  const handleOpenSubmitModal = (values) => {
    setDataForSubmit(values);
    setOpenSubmitModal(true);
  };
  const handleCloseSubmitModal = () => {
    setOpenSubmitModal(false);
  };

  const [isErrorFormSubmit, setIsErrorFormSubmit] = useState(false);
  const [isSuccessFormSubmit, setIsSuccessFormSubmit] = useState(false);

  useEffect(() => {
    if (isErrorFormSubmit) {
      setTimeout(() => {
        setIsErrorFormSubmit(false);
      }, 3000);
    }
  }, [isErrorFormSubmit]);

  useEffect(() => {
    if (isSuccessFormSubmit) {
      setTimeout(() => {
        setIsSuccessFormSubmit(false);
      }, 3000);
    }
  }, [isSuccessFormSubmit]);

  const [gstVerifyLoading, setGstVerifyLoading] = useState(false);
  const [gstVerifiedData, setGstVerifiedData] = useState(null);
  // const [gstNoValue, setGstNoValue] = useState("");
  const [gstNoValue, setGstNoValue] = useState(
    rejectedVendorData?.gstNo ? rejectedVendorData.gstNo : "",
  );

  // Auto-mark as verified if GST comes from rejectedVendorData
  useEffect(() => {
    if (rejectedVendorData?.gstNo) {
      setIsVerified(true);
    }
  }, [rejectedVendorData]);
  // console.log("gstNoValue",gstNoValue)
  // const handleVerifyGst = () => {
  //   const gstNo = gstNoValue.trim();
  //   console.log("gstNo", gstNo);

  //   if (!gstNo) {
  //     toast.error("Please enter GST number");
  //     return;
  //   }

  //   // setGstVerifyLoading(true);
  //   getDataByGstNumber(gstNo, (res) => {
  //     // setGstVerifyLoading(false);
  //     if (res?.status === "success") {
  //       setGstVerifiedData(res.data);
  //       toast.success("GST Number Verified Successfully!");
  //     } else {
  //       toast.error("Invalid GST Number");
  //     }
  //   });
  // };
  // const dataStoredForCountry = gstReducer

  const FieldError = ({ name }) => {
    const [, meta] = useField(name);

    if (!(meta.touched && meta.error)) return null;

    return (
      <div style={{ marginTop: 4, color: "red", fontSize: "0.75rem" }}>
        <TextError msg={meta.error} />
      </div>
    );
  };

  const [isVerified, setIsVerified] = React.useState(false);
  const [gstNo, setGstNo] = useState("");

  const [lastVerifiedGst, setLastVerifiedGst] = useState(""); // NEW
  // const [gstVerifiedData, setGstVerifiedData] = useState(null);
  const [shouldAutoFillSupplierName, setShouldAutoFillSupplierName] =
    useState(false);

  const handleVerifyGst = async () => {
    setGstVerifyLoading(true);
    const gstNo = gstNoValue.trim();

    if (!gstNo) {
      toast.error("Please enter GST number");
      setGstVerifyLoading(false);
      return;
    }

    let res;
    try {
      res = await getDataByGstNumber(gstNo, token);
    } catch (error) {
      // If API throws, show detailed message if available
      const apiMsg =
        error?.response?.data?.msg || error?.response?.data?.message;
      toast.error(apiMsg || "Error verifying GST number");
      setGstVerifyLoading(false);
      return;
    }

    const isSuccess =
      res?.status === true ||
      res?.status === "success" ||
      res?.statusCode === 200 ||
      res?.status === 200;

    if (isSuccess) {
      console.log("GST API response:", res.data);
      setGstVerifiedData(res?.data?.addr);
      cookies.set("gstVerifiedDataAddr", res?.data?.addr, { path: "/" });
      cookies.set("isVerifiedGST", JSON.stringify(true), {
        path: "/",
      });
      setShouldAutoFillStreet(true); // For street autofillf
      setShouldAutoFillPinCode(true);
      setShouldAutoFillState(true); // ✅ allow autofill
      setShouldAutoFillSupplierName(true); // ✅ Allow autofill
      setIsVerified(true);
      toast.success("GST Number Verified Successfully!");
    } else {
      toast.error(res?.data?.msg || res?.message || "Invalid GST Number");
    }
    console.log(gstVerifiedData);
    setGstVerifyLoading(false); // always stop loading at end
  };

  const [levelOptions, setLevelOptions] = useState([]);

  const pncd = gstReducer?.gstData?.data?.addr.pncd;
  const addrData = gstReducer?.gstData?.data?.addr;

  // const [pinCode, setPinCode] = useState("");

  // useEffect(() => {
  //   const addrData = gstReducer?.gstData?.data?.addr;
  //   if (addrData?.pncd) {
  //     setPinCode(addrData.pncd);
  //   }
  // }, [gstReducer]);
  // console.log("pinCode",pinCode)

  // const { setFieldValue } = useFormikContext();

  // useEffect(() => {
  //   const addrData = gstReducer?.gstData?.data?.addr;
  //   if (addrData?.pncd) {
  //     setFieldValue("pinCode", addrData.pncd);
  //   }
  // }, [gstReducer, setFieldValue]);

  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   const addrData = gstReducer?.gstData?.data?.addr;

  //   console.log("data", addrData);

  //   if (Array.isArray(addrData)) {
  //     addrData.forEach((level) => {
  //       tempLevelOptions.push({
  //         label: level?.rltName,
  //         value: level?.rltLevel,
  //       });
  //     });
  //   }

  //   setLevelOptions(tempLevelOptions);
  // }, [gstReducer]);

  return (
    <div>
      <BasicLayout position="relative">
        {loading ? (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : formSubmitted ? (
          <Card className="vendor-form">
            <CardContent align="center">
              <MDTypography>
                Form submitted successfully. You can close this tab!
              </MDTypography>
            </CardContent>
          </Card>
        ) : (
          <div>
            <Card className="vendor-form">
              <CardContent align="center">
                <MDBox>
                  <MDTypography
                    mb={5}
                    variant="h2"
                    fontWeight="medium"
                    style={{ display: "grid", justifyContent: "center" }}
                  >
                    Supplier Form
                  </MDTypography>

                  <MDBox>
                    <MultiStepForm
                      initialValues={initialValues}
                      onSubmit={handleOpenSubmitModal}
                      onStateChange={stateChangeHandler}
                    >
                      {/*  */}
                      {/* Step 1 form */}
                      <FormStep
                        stepName="Business Partner Details"
                        validationSchema={validationSchemaForStepOne}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "1rem" }}
                        >
                          <Grid
                            item
                            xs={12}
                            md={12}
                            lg={3}
                            style={{
                              marginTop: "-.2rem",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {/* Label */}
                            <MDTypography
                              variant="h6"
                              color="inherit"
                              style={{ marginBottom: 4 }}
                            >
                              GST No <span style={{ color: "red" }}>*</span>
                            </MDTypography>

                            <div
                              style={{ display: "flex", alignItems: "stretch" }}
                            >
                              <FormTextField
                                notRequired
                                id="gstNo"
                                name="gstNo"
                                // Add required if not verified
                                // required={!isVerified}
                                // disabled={!!gstVerifiedData}
                                inputProps={{
                                  style: {
                                    textTransform: "uppercase",
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  },
                                  maxLength: 15,
                                }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.toUpperCase();
                                  setGstNoValue(e.target.value);

                                  // reset verified state if user edits
                                  setIsVerified(false);
                                  cookies.set("gstVerifiedDataAddr", null, {
                                    path: "/",
                                  });
                                  setGstVerifiedData(null);
                                  cookies.set(
                                    "isVerifiedGST",
                                    JSON.stringify(isVerified),
                                    {
                                      path: "/",
                                    },
                                  );
                                }}
                                style={{ flex: 1 }}
                                hideError
                              />

                              <Tooltip
                                title={isVerified ? "Verified" : "Verify GST"}
                                arrow
                              >
                                <span>
                                  <MDButton
                                    variant="contained"
                                    color={isVerified ? "success" : "primary"}
                                    onClick={handleVerifyGst}
                                    disabled={gstVerifyLoading || isVerified} // ✅ only disable after verified
                                    style={{
                                      minWidth: "38px",
                                      height: "100%",
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                      padding: 0,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      boxShadow: "none",
                                    }}
                                  >
                                    {gstVerifyLoading ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      <VerifiedIcon
                                        style={{
                                          fontSize: 20,
                                          opacity: isVerified ? 1 : 0.6,
                                        }}
                                      />
                                    )}
                                  </MDButton>
                                </span>
                              </Tooltip>
                            </div>

                            {/* Error message below full width */}
                            <FieldError name="gstNo" />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={lineOfBusinessOptions}
                              label="Line of Business"
                              name="lineOfBusiness"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={currenciesOptions}
                              label="Currency"
                              name="currency"
                            />
                          </Grid>
                          <SupplierNameAutoFill
                            gstReducer={gstReducer}
                            shouldAutoFillSupplierName={
                              shouldAutoFillSupplierName
                            }
                            setShouldAutoFillSupplierName={
                              setShouldAutoFillSupplierName
                            }
                          />

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Supplier Name"
                              name="supplierName"
                              inputProps={{
                                maxLength: 45,
                              }}
                              // disabled
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Building No/Name"
                              name="buildingNoName"
                              inputProps={{
                                maxLength: 45,
                              }}
                              notRequired
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Floor"
                              name="floor"
                              notRequired
                            />
                          </Grid>
                          <StreetAutoFill
                            gstReducer={gstReducer}
                            shouldAutoFillStreet={shouldAutoFillStreet}
                            setShouldAutoFillStreet={setShouldAutoFillStreet}
                          />

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Line Address"
                              name="street"
                              inputProps={{
                                maxLength: 150,
                              }}
                              // disabled
                            />
                          </Grid>
                          {/* GST Number + Verify Button in one row */}

                          {/* Country Dropdown in next row */}
                          <Grid item xs={12} md={6} lg={3}>
                            <MDTypography variant="h6" color="inherit">
                              Country <span style={{ color: "red" }}>*</span>
                            </MDTypography>
                            <Select
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  borderRadius: 5,
                                  minHeight: "44px",
                                  height: "auto",
                                }),
                              }}
                              name="country"
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Select..."
                              options={countriesOptions}
                              value={countrySelected}
                              onChange={(option) => {
                                setCountryCodeSelected(option.phoneCode);
                                setCountrySelected(option);
                              }}
                              onFocus={() => {
                                setTouched(true);
                              }}
                            />
                            {touched && !countrySelected?.value && (
                              <TextError msg="Choose a Country" />
                            )}
                          </Grid>
                          <StateNameAutoFill
                            gstReducer={gstReducer}
                            shouldAutoFillState={shouldAutoFillState}
                            setShouldAutoFillState={setShouldAutoFillState}
                          />

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField label="State" name="state" />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField label="City" name="city" />
                          </Grid>
                          <PincodeAutoFill
                            gstReducer={gstReducer}
                            shouldAutoFillPinCode={shouldAutoFillPinCode}
                            setShouldAutoFillPinCode={setShouldAutoFillPinCode}
                          />

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField label="Pincode" name="pinCode" />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Contact Person"
                              name="contactPerson"
                              inputProps={{
                                maxLength: 45,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <MDTypography variant="h6" color="inherit">
                              Contact No <span style={{ color: "red" }}>*</span>
                            </MDTypography>
                            <FormTextField
                              name="contactNo"
                              type="tel"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {countryCodeSelected}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              style={{ width: "100%" }}
                              disabled={!countrySelected?.value}
                              notRequired
                            />
                          </Grid>
                          <EmailAutoFill />
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Email"
                              name="email"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={industrialTypeOptions}
                              label="Industrial Type"
                              name="industrialType"
                              isMulti
                              placeholder="Select all that apply"
                            />
                          </Grid>
                        </Grid>
                      </FormStep>
                      {/*  */}
                      {/*  */}
                      {/* Step 2 form */}
                      <FormStep
                        stepName="Statutory Information"
                        validationSchema={validationSchemaForStepTwo}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "1rem" }}
                        >
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="PAN"
                              name="pan"
                              inputProps={{
                                style: { textTransform: "uppercase" },
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.toUpperCase();
                              }}
                            />
                          </Grid>

                          {/* <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="GST No"
                              name="gstNo"
                              inputProps={{
                                style: { textTransform: "uppercase" },
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.toUpperCase();
                              }}
                            />
                          </Grid> */}
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={sezOptions}
                              label="Whether SEZ/Non-SEZ"
                              name="sezNonsez"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={rcmOptions}
                              label="RCM Applicable"
                              name="rcmApplicable"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="LUT No"
                              name="lutNo"
                              notRequired
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="LUT Date"
                              name="lutDate"
                              type="date"
                              notRequired
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Payment Terms"
                              name="paymentTerms"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="CIN Number"
                              name="cinNumber"
                              onInput={(e) => {
                                e.target.value = e.target.value.toUpperCase();
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={categoryOfSupplyOptions}
                              label="Category of Supply"
                              name="categoryOfSupply"
                              isMulti
                            />
                          </Grid>

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="PF Account Number"
                              name="pfAccountNumber"
                              notRequired
                            />
                          </Grid>

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="ESI Account Number"
                              name="esiAccountNumber"
                              notRequired
                            />
                          </Grid>

                          <Grid item xs={12} md={12} lg={12}>
                            <MDTypography>
                              Are you registered under MSMED Act, if yes please
                              share valid self attested certificate{" "}
                              <span style={{ color: "red" }}>*</span>
                            </MDTypography>
                            <div>
                              <label style={{ marginRight: "10px" }}>
                                <Field
                                  type="radio"
                                  value="Yes"
                                  name="msmedAct"
                                  style={{ marginRight: "5px" }}
                                />
                                Yes
                              </label>
                              <span />
                              <label>
                                <Field
                                  type="radio"
                                  value="No"
                                  name="msmedAct"
                                  style={{ marginRight: "5px" }}
                                />
                                No
                              </label>
                            </div>
                            {state.msmedAct === "" && (
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontStyle: "italic",
                                  color: "red",
                                }}
                              >
                                Required!
                              </span>
                            )}
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <MDTypography>
                              Do you have any TDS lower deduction certificate,
                              if yes provide self attested copy{" "}
                              <span style={{ color: "red" }}>*</span>
                            </MDTypography>
                            <div>
                              <label style={{ marginRight: "10px" }}>
                                <Field
                                  type="radio"
                                  value="Yes"
                                  name="tdsLowerDeduction"
                                  style={{ marginRight: "5px" }}
                                />
                                Yes
                              </label>
                              <span />
                              <label>
                                <Field
                                  type="radio"
                                  value="No"
                                  name="tdsLowerDeduction"
                                  style={{ marginRight: "5px" }}
                                />
                                No
                              </label>
                            </div>
                            {state.tdsLowerDeduction === "" && (
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontStyle: "italic",
                                  color: "red",
                                }}
                              >
                                Required!
                              </span>
                            )}
                          </Grid>
                        </Grid>
                      </FormStep>
                      {/*  */}
                      {/*  */}
                      {/* Step 3 form */}
                      <FormStep
                        stepName="Bank Details"
                        validationSchema={validationSchemaForStepThree}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "1rem" }}
                        >
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Beneficiary Bank"
                              name="beneficiaryBank"
                            />
                          </Grid>

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Bank Address"
                              name="bankAddress"
                            />
                          </Grid>

                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Account Number"
                              name="accountNumber"
                              type="number"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormSelect
                              options={accountTypeOptions}
                              label="Account Type"
                              name="accountType"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Account Name"
                              name="accountName"
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField label="IFSC Code" name="ifscCode" />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Swift Code/IBAN"
                              name="swiftCodeIban"
                              notRequired
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Swift Code Of Intermediary/RoutingBank"
                              name="swiftCodeOfIntermediaryRoutingBank"
                              notRequired
                            />
                          </Grid>
                          <Grid item xs={12} md={6} lg={3}>
                            <FormTextField
                              label="Intermediary/Routing Bank"
                              name="intermediaryRoutingBank"
                              notRequired
                            />
                          </Grid>
                        </Grid>
                      </FormStep>
                      {/*  */}
                      {/*  */}
                      {/* Step 4 form */}
                      <FormStep
                        stepName="Documents"
                        validationSchema={validationSchemaForStepFour}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{ marginTop: "1rem" }}
                        >
                          <Grid item size="auto">
                            <FormFileUpload
                              label="Incorporation Certificate"
                              name="incorporationCertificate"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments
                                  ?.incorporationCertificate
                              }
                            />
                          </Grid>
                          <Grid item size="auto">
                            <FormFileUpload
                              label="Cancelled Cheque"
                              name="cancelledCheque"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments?.cancelledCheque
                              }
                            />
                          </Grid>
                          <Grid item size="auto">
                            <FormFileUpload
                              label="PAN Card"
                              name="panCard"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments?.panCard
                              }
                            />
                          </Grid>
                          <Grid item size="auto">
                            <FormFileUpload
                              label="GST Registration Certificate"
                              name="gstRegistrationCertificate"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments
                                  ?.gstRegistrationCertificate
                              }
                            />
                          </Grid>
                          <Grid item size="auto">
                            <FormFileUpload
                              label="Valid LUT"
                              name="validLut"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments?.validLut
                              }
                              notRequired
                            />
                          </Grid>
                          <Grid item size="auto">
                            <FormFileUpload
                              label="Contract Document"
                              name="contract"
                              email={rejectedVendorData?.email}
                              isRejected={
                                rejectedVendorData?.attachments?.contract
                              }
                              notRequired
                            />
                          </Grid>
                          {state.sezNonsez === "SEZ" && (
                            <Grid item size="auto">
                              <FormFileUpload
                                label="SEZ Approval"
                                name="sezApproval"
                                email={rejectedVendorData?.email}
                                isRejected={
                                  rejectedVendorData?.attachments?.sezApproval
                                }
                                notRequired
                              />
                            </Grid>
                          )}
                          {state.pfAccountNumber && (
                            <Grid item size="auto">
                              <FormFileUpload
                                label="PF Certificate"
                                name="pfCertificate"
                                email={rejectedVendorData?.email}
                                isRejected={
                                  rejectedVendorData?.attachments?.pfCertificate
                                }
                                notRequired
                              />
                            </Grid>
                          )}
                          {state.esiAccountNumber && (
                            <Grid item size="auto">
                              <FormFileUpload
                                label="ESI Certificate"
                                name="esiCertificate"
                                email={rejectedVendorData?.email}
                                isRejected={
                                  rejectedVendorData?.attachments
                                    ?.esiCertificate
                                }
                                notRequired
                              />
                            </Grid>
                          )}
                          {state.tdsLowerDeduction == "Yes" && (
                            <Grid item size="auto">
                              <FormFileUpload
                                label="TDS Lower Deduction Certificate"
                                name="tdsLowerDeductionCertificate"
                                email={rejectedVendorData?.email}
                                isRejected={
                                  rejectedVendorData?.attachments
                                    ?.tdsLowerDeductionCertificate
                                }
                              />
                            </Grid>
                          )}
                          {state.msmedAct === "Yes" && (
                            <Grid item size="auto">
                              <FormFileUpload
                                label="MSME Certificate"
                                name="msmeCertificate"
                                email={rejectedVendorData?.email}
                                isRejected={
                                  rejectedVendorData?.attachments
                                    ?.msmeCertificate
                                }
                              />
                            </Grid>
                          )}

                          <Grid item size="auto">
                            <FormFileUpload
                              label="Other Document"
                              name="other"
                              email={rejectedVendorData?.email}
                              isRejected={rejectedVendorData?.other?.other}
                              notRequired
                            />
                          </Grid>
                        </Grid>
                      </FormStep>
                    </MultiStepForm>
                  </MDBox>
                </MDBox>
              </CardContent>
            </Card>
          </div>
        )}
        <Modal
          open={showCopyLastFilledModal}
          onClose={() => setShowCopyLastFilledModal(false)}
          aria-labelledby="copy-last-filled-modal-title"
          aria-describedby="copy-last-filled-modal-description"
        >
          <MDCard sx={submitModalStyle}>
            <MDTypography id="copy-last-filled-modal-title">
              Do you want to copy your last filled details?
            </MDTypography>
            <MDBox mt={2} display="flex">
              <MDButton
                style={{ width: "10rem", marginRight: "1rem" }}
                color="info"
                variant="outlined"
                onClick={() => setShowCopyLastFilledModal(false)}
              >
                No
              </MDButton>
              <MDButton
                style={{ width: "10rem" }}
                color="success"
                onClick={async () => {
                  setIsVerified(false);
                  setShowCopyLastFilledModal(false);
                  await getLastFilledDataByVendorId(vendorIdForLastFilled);
                  setRejectedVendorData(
                    getLastFilledDataByVendorIdReducer?.getVendor,
                  );
                  setLoading(true);
                  setTimeout(() => {
                    setIsVerified(false);
                    setLoading(false);
                  }, 3000);
                }}
              >
                Yes
              </MDButton>
            </MDBox>
          </MDCard>
        </Modal>
        <Modal
          open={openSubmitModal}
          onClose={handleCloseSubmitModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={submitModalStyle}>
            <MDTypography>Are you sure you want to Submit?</MDTypography>
            <MDBox mt={2} display="flex">
              <div>
                <MDButton
                  style={{ width: "10rem", marginRight: "1rem" }}
                  color="info"
                  variant="outlined"
                  onClick={handleCloseSubmitModal}
                >
                  Cancel
                </MDButton>
              </div>
              <div style={{ float: "right" }}>
                <MDButton
                  style={{ width: "10rem" }}
                  color="success"
                  onClick={submitFormHandler}
                >
                  Yes
                </MDButton>
              </div>
            </MDBox>
            <MDBox mt={2}>
              <Collapse in={isSuccessFormSubmit}>
                <Alert
                  severity="success"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsSuccessFormSubmit(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  Form submitted successfully!
                </Alert>
              </Collapse>
              <Collapse in={isErrorFormSubmit}>
                <Alert
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsErrorFormSubmit(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  {errorMsgFormSubmit}
                </Alert>
              </Collapse>
            </MDBox>
          </MDCard>
        </Modal>
        <ToastContainer />
      </BasicLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    rejectedVendorReducer: state.getVendorByVendorIdReducer,
    vendorIdReducer: state.getVendorIdReducer,
    gstReducer: state.gstReducer,
    getLastFilledDataByVendorIdReducer:
      state.getLastFilledDataByVendorIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    createVendorDetails: (payload, token) =>
      dispatch(createVendorDetails(payload, token)),
    rejectedVendorDetails: (payload, token) =>
      dispatch(rejectedVendorDetails(payload, token)),
    getDataByGstNumber: (gst, token) =>
      dispatch(getDataByGstNumber(gst, token)),
    getRejectedVendorDetails: (vendorId) =>
      dispatch(getVendorByVendorId(vendorId)),
    getLastFilledDataByVendorId: (vendorId) =>
      dispatch(getLastFilledDataByVendorId(vendorId)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(StandardVendorForm);
